// Customer-facing service names for the booking forms' titles ("Book
// Handyman") and success screen. Keys are the requestType values from
// GetServiceCategorySettings; anything missing falls back to the requestType.
const SERVICE_LABELS = {
    "Aircon Services": "Aircon Service",
    "Handyman Services": "Handyman",
    "Domestic Services": "Helper",
    "Fitness Trainer": "Personal Trainer",
    "Housing": "Property Agent",
    "Financial": "Financial Adviser",
}

export const bookingServiceLabel = (requestType) => SERVICE_LABELS[requestType] || requestType || ""
